import React__default from 'react';
import { Breadcrumbs } from '@grandvisionhq/common';
import { Container } from '@grandvisionhq/elements';

const ProductCatalogBreadcrumbs = ({ breadcrumbs  })=>{
    return /*#__PURE__*/ React__default.createElement(Container, {
        className: "product-catalog-breadcrumbs"
    }, /*#__PURE__*/ React__default.createElement(Breadcrumbs, {
        pages: breadcrumbs
    }));
};

export { ProductCatalogBreadcrumbs };
//# sourceMappingURL=ProductCatalogBreadcrumbs.js.map
